import WithAuth from "../components/hoc/with-auth"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import { Flex, Text, Box } from "@chakra-ui/react"
import FrequentTradesPage from "../components/pages/frequent-trades-page"

const FrequentTrades = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Frequent Tades"
          pageDesc="Trades with shortest durations"
        >
          <FrequentTradesPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default FrequentTrades
